const userOnboardingStage = {
    OrganisationSetup: 'OrganisationSetup',
    AccountDetails: 'AccountDetails',
    Complete: 'Complete',
    NotRequired: 'NotRequired',
};

export default userOnboardingStage;
